import { Component, createRef } from 'react'
import _ from 'lodash'

class BaseChartModule extends Component {
  constructor (props) {
    super(props)
    this.state = {}
    this.chart = createRef()
  }

  initChart = ref => {
    this.chart = ref
  }

  calcMaxDomain = (minimalSize = 4) => dataMax => {
    // 取得 recharts 計算該軸最大值
    const dataSize = _.size(`${dataMax}`)
    // 扣掉從次大的位數，取得最接近的值
    const closestData = _.floor(dataMax, (dataSize - 1) * -1)
    const diffData = dataMax - closestData
    // 從次大的位數進位取得超過比 recharts 計算出來最大值多一些才能確保該軸最大值超過資料的最大值
    const domainMaxSize = closestData + _.ceil(diffData || 1, (dataSize - 1) * -1)
    if (domainMaxSize < minimalSize) {
      return minimalSize
    }
    return domainMaxSize
  }

  render () {
    return this.render()
  }
}

export default BaseChartModule
